import { Badge, Calendar } from "antd";
import moment from "moment";
import React, { FC, useEffect, useState } from "react";
import "./index.scss";

import FullCalendar, {
  EventApi,
  DateSelectArg,
  EventClickArg,
  EventContentArg,
} from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import rrulePlugin from "@fullcalendar/rrule";
import AddEventModal from "components/Modals/AddEventModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";

let eventGuid = 0;

export function createEventId() {
  return String(eventGuid++);
}

const EventCalendarPreview: FC<{ theme?: any }> = ({ theme }) => {
  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const [selectedEvent, setSelectedEvent] = useState<any>();
  const [currentEvents, setCurrentEvents] = useState([]);
  const { userSchedule } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (userSchedule) {
      const parsedEvents = [];
      userSchedule.map((schedule) => {
        let event = schedule.info.calendar;
        let start = new Date(event.dateTime);
        parsedEvents.push({
          ...event,
          objectId: schedule.objectId,
          title: `${event.title}`,
          id: createEventId(),
          start,
          rrule: event.repeat
            ? {
                freq: event.repeatFrequency,
                interval: event.repeatAfter,
                dtstart: start,
                until:
                  event.repeatUntil
                    ? new Date(event.repeatUntil)
                    : undefined,
              }
            : undefined,
        });
      });
      setCurrentEvents(parsedEvents);
    }
  }, [userSchedule]);

  const handleDateSelect = (selectInfo: DateSelectArg) => {
    let title = prompt("Please enter a new title for your event");
    let calendarApi = selectInfo.view.calendar;

    calendarApi.unselect(); // clear date selection

    if (title) {
      calendarApi.addEvent({
        id: new Date().getTime().toString(),
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay,
      });
    }
  };

  const handleEventClick = (clickInfo: EventClickArg) => {
    const event = clickInfo.event.toPlainObject();
    setSelectedEvent({
      ...event.extendedProps,
      title: event.title,
      date: event.start,
    });
  };

  const renderEventContent = (eventContent: EventContentArg) => {
    return (
      <>
        <b>{eventContent.timeText}</b>
        <i>{eventContent.event.title}</i>
      </>
    );
  };

  return (
    <div className="clock">
      <div>
        <div>
          <FullCalendar
            plugins={[
              rrulePlugin,
              dayGridPlugin,
              timeGridPlugin,
              interactionPlugin,
            ]}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            initialView="dayGridMonth"
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={true}
            weekends={weekendsVisible}
            events={currentEvents}
            select={handleDateSelect}
            eventContent={renderEventContent} // custom render function
            eventClick={handleEventClick}
          />
        </div>
      </div>

      {selectedEvent && (
        <AddEventModal
          onClose={() => setSelectedEvent(undefined)}
          eventObj={selectedEvent}
          id={selectedEvent.eventId}
        />
      )}
    </div>
  );
};
export default EventCalendarPreview;
